import { render, staticRenderFns } from "./ParceiroForm.vue?vue&type=template&id=e09ec832&scoped=true&"
import script from "./ParceiroForm.vue?vue&type=script&lang=js&"
export * from "./ParceiroForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09ec832",
  null
  
)

export default component.exports